import PropTypes from 'prop-types';

import {captureError} from '../../../../../utils/log';

import FieldView from './FieldView';

function FieldContainer({field, isLast}) {
  async function handleCopyValue() {
    try {
      const valueToCopy = field.value;
      const cb = navigator.clipboard;
      await cb.writeText(valueToCopy);
    } catch (error) {
      captureError('Error while copying secured value to clipboard', error);
    }
  }

  return (
    <FieldView
      field={field}
      decryptedValue={null}
      loading={false}
      onShowValue={() => { /* placeholder function */ }}
      onCopyValue={handleCopyValue}
      isLast={isLast}
    />
  );
}

FieldContainer.propTypes = {
  field: PropTypes.object.isRequired,
  isLast: PropTypes.bool.isRequired
};

export default FieldContainer;
